<template>
  <div v-if="isHaveMerNo">
    <div class="common-info-title">{{ name }}</div>
    <el-row class="parent">
      <el-col :span="24" class="toolbar formbg" style="padding-bottom: 0px">
        <el-row>
          <el-form
            ref="searchForm"
            :inline="true"
            class="form-search inputStyle"
            :model="searchForm"
            label-width="110px"
          >
            <el-form-item
              label="账单日期："
              style="margin-left: 10px"
              prop="fileTime"
            >
              <el-date-picker
                style="width: 270px"
                v-model="searchForm.fileTime"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                unlink-panels
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              />
            </el-form-item>
            <el-form-item label="操作：" class="operateStyle">
              <el-button
                type="primary"
                size="medium"
                :loading="listLoading"
                @click="getData()"
                >查询</el-button
              >
              <el-button size="medium" @click="clearUp()">重置</el-button>
            </el-form-item>
          </el-form>
        </el-row>
      </el-col>
      <div>
        <!-- 列表渲染开始 -->
        <div style="margin-top: 10px">
          <el-table
            v-loading="listLoading"
            stripe
            max-height="800"
            class="common-list"
            :data="tableData"
            border
            row-key="id"
            element-loading-text="数据加载中，请稍等"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            <el-table-column label="序号" type="index" width="50" />
            <el-table-column prop="fileName" label="文件名称" width="360">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click="handleDownload(scope.row)"
                  >{{ scope.row.fileName }}</el-button
                >
              </template>
            </el-table-column>
            <el-table-column prop="fileTime" label="文件日期" />
            <el-table-column prop="fileSize" label="文件大小" />
          </el-table>
        </div>
      </div>
      <!--分页工具条-->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="page"
        :limit.sync="size"
        :current-page="page"
        @pagination="getDataByPage()"
      />
    </el-row>
    <div v-if="!isHaveMerNo" class="tips">请先开通商户</div>
  </div>
</template>
<script>
import {
  getData,
  getDownloadData,
} from "@/api/crossborder/settle/reconciliaFile";
import Pagination from "@/components/Pagination/index"; // 分页
import Common from "@/utils/common"; // 工具类
import File from "@/utils/file";
export default {
  name: "Declare",
  components: {
    Pagination,
  },
  data: function () {
    return {
      isHaveMerNo: true,
      tableData: [],
      name: null,
      searchForm: {
        fileTime: null,
      },
      // 列表loading
      listLoading: false,
      downloadLoading: false,
      total: 0, // 分页总条数
      page: 1, // 分页页码
      size: 10,
    };
  },
  created() {
    if (!this.$store.state.user.merNo) {
      this.isHaveMerNo = false;
    }
  },
  methods: {
    getData() {
      this.page = 1;
      this.getDataByPage();
    },
    getDataByPage() {
      this.tableData = [];
      const param = Common.setNull({
        page: this.page ? this.page : 1,
        size: this.size ? this.size : 10,
        merNo: this.$store.getters.merNo,
        startFileTime: this.searchForm.fileTime
          ? this.searchForm.fileTime[0]
          : null,
        endFileTime: this.searchForm.fileTime
          ? this.searchForm.fileTime[1]
          : null,
      });
      this.listLoading = true;
      getData(param)
        .then((res) => {
          this.listLoading = false;
          if (res.data.list) this.tableData = res.data.list;
          this.total = res.data.total;
        })
        .catch((error) => {
          this.listLoading = false;
          console.log(error); // 请求失败返回的数据
        });
    },

    // 下载
    handleDownload(row) {
      const param = { fileUrl: row.filePath };
      this.listLoading = true;

      getDownloadData(param)
        .then((res) => {
          this.listLoading = false;
          File.output(res);
        })
        .catch((error) => {
          this.listLoading = false;
          console.error(error);
        });

      // File.download(param)
      //   .then((response) => {
      //     this.listLoading = false
      //     // console.log(response)
      //     File.output(response)
      //   })
      //   .catch((error) => {
      //     this.listLoading = false
      //     console.error(error)
      //   })
    },
    // 重置
    clearUp() {
      this.searchForm.fileTime = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.show-img {
  width: 100%;
  max-width: 500px;
  height: 280px;
}
::v-deep .inputStyle .el-form-item__content {
  width: 200px;
}
::v-deep .operateStyle .el-form-item__content {
  width: 300px;
}
</style>
